import { LocationVarKey } from "@swivl-mono/types";
import { Button, ButtonSize, ButtonVariant } from "@swivl-mono/ui";
import { useState } from "react";
import { FiPlusCircle } from "react-icons/fi";
import { useLocation } from "react-router-dom";

import { SMSCampaignButton } from "../../../../../Views/ContactCenter/Conversations/Components/SMSCampaignButton/SMSCampaignButton";
import { MembersOnlineSection } from "../../../../../Views/ContactCenter/Conversations/MembersOnlineSection";
import { SnowyCampaignButton } from "../../../../../Views/ContactCenterV3/Campaigns/SnowyCampaignButton";
import { NewOutboundCallModal } from "../../../../../Views/ContactCenterV3/Conversations/NewOutboundCallModal";
import "./NavBarRightSection.scss";
import { UserAvatarPopover } from "./UserAvatarPopover";

export function NavBarRightSection(): React.ReactNode {
  const { pathname } = useLocation();
  const [callModalOpen, setCallModalOpen] = useState(false);
  // ONE SMS campaign button, gate picked by surface (ENG-2946): the v3
  // (Snowy) routes gate on the Cortex var — Snowy surfaces never read legacy
  // keys — while the legacy CC keeps HasSMSCampaigns. Both on ≠ two buttons.
  const isV3Surface = pathname.startsWith("/contact-center-v3/conversations");
  const showSMSCampaignButton =
    isV3Surface || pathname.startsWith("/contact-center/conversations") || pathname.startsWith("/contact-center/recordings");

  const handleOpenCallModal = (): void => setCallModalOpen(true);

  return (
    <div className="flex items-center gap-3">
      {showSMSCampaignButton && (
        // Extra breathing room between the button and the agents-online
        // indicator (Chuck, 2026-07-27) — the container gap-3 alone was tight.
        // CC v3 (Snowy) gets the Snowy compose modal (ENG-3114); legacy routes keep the legacy one.
        <span className="mr-2">{isV3Surface ? <SnowyCampaignButton /> : <SMSCampaignButton gateVarKey={LocationVarKey.HasSMSCampaigns} />}</span>
      )}
      {/* New Conversation — a call (ENG-3018) or a text (ENG-3592). CC v3 (Snowy) surface only. */}
      {isV3Surface && (
        <span className="mr-2">
          <Button size={ButtonSize.SMALL} variant={ButtonVariant.GHOST} onClick={handleOpenCallModal}>
            <FiPlusCircle size={13} /> New Conversation
          </Button>
          {callModalOpen && <NewOutboundCallModal open={callModalOpen} onClose={() => setCallModalOpen(false)} />}
        </span>
      )}
      <MembersOnlineSection />
      {/* <NotificationBellIcon /> */}
      <UserAvatarPopover />
    </div>
  );
}
